export const sortingPropertiesReducerKey = 'SortingPropertiesReducer';

export const saveSortingPropertiesType = 'saveSortingPropertiesType';

export const similarityMolKey = 'similarityMol';
